import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import taskViewerService from 'services/taskViewerService';
import { TaskViewerConfig } from 'types/Tasks';

export const useTaskViewerFeatures = () => {
  return useQuery<TaskViewerConfig, AxiosError>({
    queryKey: ['taskViewerFeatures'],
    queryFn: taskViewerService.getFeaturesAvailability,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
